import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const ReportWidgetCard = ({ children, wideLayout = false, className }) => (
  <div className={cx('report-widget-card', wideLayout && 'report-widget-card--wide', className)}>
    {children}
  </div>
);

ReportWidgetCard.propTypes = {
  children: T.node.isRequired,
  wideLayout: T.bool,
  className: T.string,
};

export default ReportWidgetCard;
